/**
 * UI strings that do not come from the CMS.
 *
 * Deliberately a plain object rather than a library: the set is small, it must be
 * type-checked, and a missing key should be obvious at build time. Swap in a proper
 * i18n library when the string count justifies it.
 */
const STRINGS = {
  en: {
    'nav.menu': 'Menu', 'nav.language': 'Language', 'nav.region': 'Region',
    'a11y.skipToContent': 'Skip to content', 'a11y.mainNav': 'Main', 'a11y.footerNav': 'Footer',
    'a11y.chooseLanguage': 'Language', 'a11y.chooseRegion': 'Choose a region', 'a11y.languageNamed': 'Switch to {name}',
    'a11y.home': 'Weco-Travel - home', 'a11y.sectionNav': 'In this section', 'a11y.openMenu': 'Open menu', 'a11y.closeMenu': 'Close menu', 'a11y.languageAndRegion': 'Language and region',
    'a11y.tileLink': 'More',
    'page.loading': 'Loading…', 'page.notFound': 'Page not found',
    'page.notFoundBody': 'This page does not exist in this region, or has not been published yet.',
    'page.error': 'Content could not be loaded', 'page.home': 'Back to the homepage',
    'page.errorBody': 'The CMS did not respond. Check that it is running and reachable.',
    'section.unknown': 'Unknown section type',
    'section.empty': 'This section has no content yet.',
    'news.readMore': 'Read more', 'news.all': 'See more', 'news.empty': 'No articles yet.',
    'news.kindNews': 'News', 'news.kindBlog': 'Blog',
    'video.play': 'Play the video', 'cta.check': 'Find out more', 'footer.subscribe': 'Subscribe',
    'footer.subscribing': 'Subscribing…',
    // Double opt-in: they are not subscribed until they click the link, so the message
    // has to say so. "Thank you for subscribing" would be untrue and would stop them
    // looking for the e-mail that finishes the job.
    'footer.newsletterSuccess': 'Almost done - check your inbox and confirm your subscription.',
    'footer.newsletterError': 'The sign-up could not be completed. Please try again.',
    'news.allCategories': 'All', 'news.categories': 'Filter by category',
    'news.pagination': 'Pages', 'news.previous': 'Previous', 'news.next': 'Next',
    'news.page': 'Page', 'news.pageOf': 'Page {page} of {pages}',
    'form.department': 'Choose the relevant department', 'form.departmentPlaceholder': 'Department…',
    'form.contactPerson': 'Contact person', 'form.email': 'E-mail', 'form.phone': 'Phone',
    'form.message': 'How can we help?', 'form.consent': 'I agree to the privacy policy',
    'form.submit': 'Send', 'form.sending': 'Sending…',
    'form.success': 'Thank you. Your message has been sent.',
    'form.error': 'The message could not be sent. Please try again.',
    'form.required': 'This field is required', 'form.invalidEmail': 'Enter a valid e-mail address',
    'form.tooShort': 'Please write a little more',
    'form.offices': 'Contact details',
    'country.select': 'Choose a country', 'country.requirements': 'Check the requirements', 'country.documents': 'Documents', 'country.capital': 'Capital'
  ,
    'preview.notice': 'Preview - you are seeing unpublished content, not the live site.',
    'preview.exit': 'Leave preview',
    // The photo text slider. `carousel` and `slide` are read out as what the element is
    // (aria-roledescription), so they are nouns in the visitor's language, not labels.
    'slider.carousel': 'carousel', 'slider.slide': 'slide', 'slider.position': '{index} of {count}',
    'slider.previous': 'Previous slide', 'slider.next': 'Next slide'
  },
  pl: {
    'nav.menu': 'Menu', 'nav.language': 'Język', 'nav.region': 'Region',
    'a11y.skipToContent': 'Przejdź do treści', 'a11y.mainNav': 'Główne', 'a11y.footerNav': 'Stopka',
    'a11y.chooseLanguage': 'Język', 'a11y.chooseRegion': 'Wybierz region', 'a11y.languageNamed': 'Przełącz na {name}',
    'a11y.home': 'Weco-Travel - strona główna', 'a11y.sectionNav': 'W tym dziale', 'a11y.openMenu': 'Otwórz menu', 'a11y.closeMenu': 'Zamknij menu', 'a11y.languageAndRegion': 'Język i region',
    'a11y.tileLink': 'Więcej',
    'page.loading': 'Ładowanie…', 'page.notFound': 'Nie znaleziono strony',
    'page.notFoundBody': 'Ta strona nie istnieje w tym regionie lub nie została jeszcze opublikowana.',
    'page.error': 'Nie udało się wczytać treści', 'page.home': 'Wróć na stronę główną',
    'page.errorBody': 'CMS nie odpowiedział. Sprawdź, czy jest uruchomiony i dostępny.',
    'section.unknown': 'Nieznany typ sekcji',
    'section.empty': 'Ta sekcja nie ma jeszcze treści.',
    'news.readMore': 'Czytaj więcej', 'news.all': 'Sprawdź więcej', 'news.empty': 'Brak wpisów.',
    'news.kindNews': 'Aktualności', 'news.kindBlog': 'Blog',
    'video.play': 'Odtwórz film', 'cta.check': 'Sprawdź', 'footer.subscribe': 'Subskrybuj',
    'footer.subscribing': 'Zapisywanie…',
    'footer.newsletterSuccess': 'Prawie gotowe - sprawdź skrzynkę i potwierdź zapis.',
    'footer.newsletterError': 'Nie udało się zapisać. Spróbuj ponownie.',
    'news.allCategories': 'Wszystkie', 'news.categories': 'Filtruj po kategorii',
    'news.pagination': 'Strony', 'news.previous': 'Poprzednia', 'news.next': 'Następna',
    'news.page': 'Strona', 'news.pageOf': 'Strona {page} z {pages}',
    'form.department': 'Wybierz odpowiedni dział/departament', 'form.departmentPlaceholder': 'Dział…',
    'form.contactPerson': 'Osoba kontaktowa', 'form.email': 'E-mail', 'form.phone': 'Telefon',
    'form.message': 'W czym możemy pomóc?', 'form.consent': 'Zgadzam się z polityką prywatności',
    'form.submit': 'Wyślij', 'form.sending': 'Wysyłanie…',
    'form.success': 'Dziękujemy. Wiadomość została wysłana.',
    'form.error': 'Nie udało się wysłać wiadomości. Spróbuj ponownie.',
    'form.required': 'To pole jest wymagane', 'form.invalidEmail': 'Podaj poprawny adres e-mail',
    'form.tooShort': 'Napisz trochę więcej',
    'form.offices': 'Dane kontaktowe',
    'country.select': 'Wybierz państwo', 'country.requirements': 'Sprawdź wymogi', 'country.documents': 'Dokumenty', 'country.capital': 'Stolica'
  ,
    'preview.notice': 'Podgląd - widzisz treść nieopublikowaną, a nie stronę na żywo.',
    'preview.exit': 'Wyjdź z podglądu',
    'slider.carousel': 'karuzela', 'slider.slide': 'slajd', 'slider.position': '{index} z {count}',
    'slider.previous': 'Poprzedni slajd', 'slider.next': 'Następny slajd'
  },
  cs: {
    'nav.menu': 'Menu', 'nav.language': 'Jazyk', 'nav.region': 'Region',
    'a11y.skipToContent': 'Přejít k obsahu', 'a11y.mainNav': 'Hlavní', 'a11y.footerNav': 'Patička',
    'a11y.chooseLanguage': 'Jazyk', 'a11y.chooseRegion': 'Vyberte region', 'a11y.languageNamed': 'Přepnout na {name}',
    'a11y.home': 'Weco-Travel - úvodní stránka', 'a11y.sectionNav': 'V této sekci',
    'a11y.openMenu': 'Otevřít menu', 'a11y.closeMenu': 'Zavřít menu', 'a11y.languageAndRegion': 'Jazyk a region', 'a11y.tileLink': 'Více',
    'page.loading': 'Načítání…', 'page.notFound': 'Stránka nenalezena',
    'page.notFoundBody': 'Tato stránka v tomto regionu neexistuje nebo zatím nebyla publikována.',
    'page.error': 'Obsah se nepodařilo načíst', 'page.home': 'Zpět na úvodní stránku',
    'page.errorBody': 'CMS neodpověděl. Zkontrolujte, zda běží a je dostupný.',
    'section.unknown': 'Neznámý typ sekce',
    'section.empty': 'Tato sekce zatím nemá obsah.',
    'news.readMore': 'Číst více', 'news.all': 'Zobrazit více', 'news.empty': 'Zatím žádné příspěvky.',
    'news.kindNews': 'Aktuality', 'news.kindBlog': 'Blog',
    'video.play': 'Přehrát video', 'cta.check': 'Zjistit více', 'footer.subscribe': 'Odebírat',
    'footer.subscribing': 'Přihlašování…',
    'footer.newsletterSuccess': 'Téměř hotovo - zkontrolujte schránku a potvrďte přihlášení.',
    'footer.newsletterError': 'Přihlášení se nezdařilo. Zkuste to prosím znovu.',
    'news.allCategories': 'Vše', 'news.categories': 'Filtrovat podle kategorie',
    'news.pagination': 'Stránky', 'news.previous': 'Předchozí', 'news.next': 'Další',
    'news.page': 'Stránka', 'news.pageOf': 'Stránka {page} z {pages}',
    'form.department': 'Vyberte příslušné oddělení', 'form.departmentPlaceholder': 'Oddělení…',
    'form.contactPerson': 'Kontaktní osoba', 'form.email': 'E-mail', 'form.phone': 'Telefon',
    'form.message': 'S čím vám můžeme pomoci?', 'form.consent': 'Souhlasím se zásadami ochrany osobních údajů',
    'form.submit': 'Odeslat', 'form.sending': 'Odesílání…',
    'form.success': 'Děkujeme. Zpráva byla odeslána.',
    'form.error': 'Zprávu se nepodařilo odeslat. Zkuste to prosím znovu.',
    'form.required': 'Toto pole je povinné', 'form.invalidEmail': 'Zadejte platnou e-mailovou adresu',
    'form.tooShort': 'Napište prosím trochu více',
    'form.offices': 'Kontaktní údaje',
    'country.select': 'Vyberte zemi', 'country.requirements': 'Zkontrolovat požadavky', 'country.documents': 'Dokumenty', 'country.capital': 'Hlavní město'
  ,
    'preview.notice': 'Náhled - vidíte nepublikovaný obsah, nikoli živý web.',
    'preview.exit': 'Ukončit náhled',
    'slider.carousel': 'karusel', 'slider.slide': 'snímek', 'slider.position': '{index} z {count}',
    'slider.previous': 'Předchozí snímek', 'slider.next': 'Další snímek'
  }
} as const;

export type StringKey = keyof typeof STRINGS.en;

/**
 * Every table must carry every key.
 *
 * `t` falls back to English for a missing one, which keeps the page working - and hides
 * a half-finished translation for as long as nobody looks at that screen. This makes it
 * a build error instead: adding a key to `en` and forgetting the others no longer
 * compiles.
 *
 * The check is the value everything else reads, which is the part worth keeping. It used
 * to be a second const that nothing used, with `void` after it to stop the compiler
 * saying so - a variable whose only job was to be type-checked, and an operator whose only
 * job was to hide that. `t` now reads `TABLES`, so the annotation is load-bearing rather
 * than ceremonial: a table missing a key fails the build here, on the object the site
 * actually uses.
 */
const TABLES: Record<keyof typeof STRINGS, Record<StringKey, string>> = STRINGS;

/**
 * Which table a language reads.
 *
 * `ro`, `hu` and `sk` fall back to English, and the reason has shrunk to one thing: nobody
 * from those markets has reviewed a table, and an unreviewed one sitting in the repository
 * looks like a decision. It used to also be that they had no content at all, which stopped
 * being true on 2026-09-04 - so this is now **visible**, as a Hungarian contact page whose
 * department picker reads "Department…". It wants a speaker of each, not another
 * postponement. `cs` is here because Czechia has content and a Czech page with an English
 * "Department…" is a defect a visitor sees.
 *
 * Listing a locale that maps to `en` is not redundant: it is the difference between a
 * decision and an oversight, and `t` treats an unlisted locale the same way.
 *
 * A missing key falls through to English rather than rendering blank - see `t`.
 */
const LOCALE_TO_TABLE: Record<string, keyof typeof STRINGS> =
  { pl: 'pl', en: 'en', cs: 'cs', ro: 'en', hu: 'en', sk: 'en' };

export function t(locale: string, key: StringKey): string {
  const table = TABLES[LOCALE_TO_TABLE[locale] ?? 'en'];
  return table[key] ?? TABLES.en[key];
}

export function makeT(locale: string) {
  return (key: StringKey, vars?: Record<string, string | number>) => {
    const value = t(locale, key);
    if (!vars) return value;
    return value.replace(/\{(\w+)}/g, (match, name) => String(vars[name] ?? match));
  };
}

/**
 * A published date in the reader's language, e.g. `07 grudnia 2024`.
 *
 * The Figma mock-ups write dates as `07.Grudnia.2024`, which is not how Polish - or
 * Czech, Romanian, Hungarian or Slovak - punctuates a date, and the file even misspells
 * the month. `Intl` gets every one of them right, so it wins over the mock-up. Raise it
 * with the designer if the dotted form was a deliberate typographic choice.
 */
export function formatDate(locale: string, value?: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'long', year: 'numeric' }).format(date);
  } catch {
    return value;
  }
}
